module.exports = __webpack_public_path__ + "img/10.04ed12c3.png";